import React from 'react';
import { useTranslation } from 'react-i18next';
import { getProfileAgeDisplay } from './profileAge';

type Props = {
    birthdate?: string;
};

const ProfileAgeRow = ({ birthdate }: Props): JSX.Element => {
    const { t } = useTranslation();
    const ageDisplay = getProfileAgeDisplay(birthdate);

    return (
        <div className="frontpage__profile-details-row">
            <span className="frontpage__profile-label">{t('Age')}</span>
            <span>
                {ageDisplay ? `${ageDisplay.age} (${ageDisplay.formattedBirthdate})` : t('No birthdate configured')}
            </span>
        </div>
    );
};

export default ProfileAgeRow;
